import React from 'react';
import { Link } from 'react-router-dom';

function MHPGuidePage() {
  const steps = [
    { title: 'Create Profile', desc: 'Fill in your credentials, experience and specialisations.' },
    { title: 'Verify Details', desc: 'Our team reviews your documents to ensure platform safety.' },
    { title: 'Configure Wallet', desc: 'Set your own consultation fees and bank details for direct payouts.' },
    { title: 'Start Practicing', desc: 'Sync your calendar and start accepting session requests.' }
  ];

  return (
    <div style={{ background: '#fdfbff', minHeight: '100vh' }}>
      <section className="page-header">
        <div className="page-header__bg" style={{ backgroundImage: 'url(/assets/images/backgrounds/slider-2-1.jpg)' }}></div>
        <div className="container">
          <div className="page-header__inner">
            <h2 className="page-header__title">Practitioner Onboarding Guide</h2>
            <ul className="thm-breadcrumb">
              <li><Link to="/">Home</Link></li>
              <li><span>/</span></li>
              <li><span>MHP Guide</span></li>
            </ul>
          </div>
        </div>
      </section>

      <section style={{ padding: '100px 0' }}>
        <div className="container">
          <div className="row align-items-center">
            {/* Guide Book Visual Placeholder */}
            <div className="col-lg-5 mb-5 mb-lg-0 wow fadeInLeft">
              <div style={{
                position: 'relative',
                background: '#fff',
                padding: '40px',
                borderRadius: '24px',
                boxShadow: '0 30px 60px rgba(124, 58, 237, 0.1)',
                border: '1px solid #f3f0ff',
                textAlign: 'center'
              }}>
                <div style={{
                  width: '100%',
                  height: '350px',
                  background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: '#fff',
                  marginBottom: '30px',
                  boxShadow: 'inset 0 0 50px rgba(0,0,0,0.1)'
                }}>
                  <span style={{ fontSize: '5rem' }}>📖</span>
                  <h3 style={{ color: '#fff', fontWeight: 800, marginTop: '20px' }}>Practitioner<br />Handbook</h3>
                  <p style={{ opacity: 0.8 }}>Digital Edition 2026</p>
                </div>
                <h4 style={{ fontWeight: 800, color: '#2d2d4d' }}>The Guide to Successful Practice</h4>
                <p style={{ color: '#6b7280' }}>Download our comprehensive manual on how to grow your digital clinic using PsychMitra.</p>
                <button className="thm-btn" style={{ borderRadius: '12px', padding: '12px 30px' }}>Read Manual</button>
              </div>
            </div>

            {/* Steps and Content */}
            <div className="col-lg-7 wow fadeInRight">
              <div style={{ paddingLeft: '40px' }}>
                <span style={{ color: '#7c3aed', fontWeight: 800, fontSize: '0.9rem', textTransform: 'uppercase', letterSpacing: '2px' }}>Why join us?</span>
                <h2 style={{ fontSize: '2.8rem', fontWeight: 900, color: '#1f2937', margin: '15px 0 30px' }}>Empowering Your <span style={{ color: '#7c3aed' }}>Professional</span> Growth</h2>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginBottom: '40px' }}>
                  {steps.map((s, i) => (
                    <div key={i} style={{ padding: '25px', background: '#fff', borderRadius: '16px', border: '1px solid #f3f4f6' }}>
                      <div style={{ width: '35px', height: '35px', borderRadius: '50%', background: '#7c3aed', color: '#fff', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold', marginBottom: '15px' }}>{i + 1}</div>
                      <h5 style={{ fontWeight: 800 }}>{s.title}</h5>
                      <p style={{ margin: 0, color: '#6b7280', fontSize: '0.9rem' }}>{s.desc}</p>
                    </div>
                  ))}
                </div>

                <div style={{ background: 'rgba(124, 58, 237, 0.05)', padding: '30px', borderRadius: '20px', border: '1px dashed #7c3aed', marginBottom: '40px' }}>
                  <h4 style={{ fontWeight: 800 }}>🌿 A Space for Tranquility</h4>
                  <p style={{ color: '#6b7280', margin: 0 }}>We handle the logistics—scheduling, payments, and reminders—so you can focus entirely on what you do best: healing.</p>
                </div>

                <Link to="/pricing" className="thm-btn" style={{ padding: '18px 50px', fontSize: '1.2rem', fontWeight: 800, borderRadius: '18px' }}>Register as Practitioner</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MHPGuidePage;
